import { Pipe, PipeTransform } from '@angular/core';
import { UserRightsEnum, UserRightDesignation } from '@evasys/globals/shared/enums/business/user-rights.enum';
import { TranslateService } from '@evasys/evasys/shared/core';

@Pipe({
	name: 'translateRoles',
})
export class TranslateRolesPipe implements PipeTransform {
	public constructor(private readonly translateService: TranslateService) {}

	public transform(roleBitmap: number, filter: UserRightsEnum[] = []): string[] {
		let userRoles: UserRightsEnum[];
		if (filter.length) {
			userRoles = filter;
		} else {
			userRoles = Object.keys(UserRightDesignation).map((role) => parseInt(role));
		}

		const roleStrings: string[] = [];
		for (const role of userRoles) {
			if (TranslateRolesPipe.roleInBitmap(roleBitmap, role)) {
				const langKey = UserRightDesignation[role];
				if (langKey) {
					roleStrings.push(this.translateService.translate(langKey));
				}
			}
		}
		return roleStrings;
	}

	private static roleInBitmap(bitmap: number, role: UserRightsEnum): boolean {
		return (bitmap & role) !== 0;
	}
}
